import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Root = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`

export const BackgroundContainer = styled.div`
  position: absolute;
  overflow: hidden;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 240px;

  ${media.sm`
    height: 100%;
  `}
`

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 5;

  ${({ theme }) => `
    color: ${theme.color.white};
  `}

  ${media.sm`
    flex-direction: row;
    min-height: 500px;
  `}
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  position: relative;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 240px;

  ${({ theme }) => `
    padding: ${theme.space.desktop.large} 0 ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    flex: 1 0;
    padding: ${theme.space.desktop.base} ${theme.space.desktop.base} ${theme.space.desktop.large} 0;
  `}
`

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  flex-shrink: 0;

  ${media.sm`
    width: 310px;
  `}
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1 0;
`

export const ContentInfo = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    color: ${theme.color.white};

    a {
      color: ${theme.color.white};
    }
  `}
`

export const Title = styled.div`
  word-break: break-word;

  @supports (-webkit-line-clamp: 4) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;

    ${media.sm`
      -webkit-line-clamp: 6;
    `}
  }
`

export const SubTitle = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};
  `}

  a {
    text-decoration: underline;
  }
`
